namespace TabAurous.ProductDevelopment {
    export namespace POSCustomerRequirementItemsService {
        export const baseUrl = 'ProductDevelopment/POSCustomerRequirementItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/POSCustomerRequirementItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSCustomerRequirementItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
